( function( app ) {
  const COMPONENT = {
    init: function() {
      const el = document.querySelector( '[data-component="cost-calculator"]' );
      if ( !el ) return;

      el.querySelector( '[data-js="calculator-form"]' ).addEventListener( 'submit', function( e ) {
        e.preventDefault();
        COMPONENT.calculate( el );
      } );
    },

    calculate: function( el ) {
      const invoiceAmount = parseFloat( el.querySelector( '[data-js="invoice-amount"]' ).value ) || 0;
      const advanceRate = parseFloat( el.querySelector( '[data-js="advance-rate"]' ).value ) || 0;
      const factoringFeePercent = parseFloat( el.querySelector( '[data-js="factoring-fee"]' ).value ) || 0;

      if ( invoiceAmount <= 0 ) {
        alert( 'Please enter a valid invoice amount.' );
        return;
      }

      const advanceAmount = invoiceAmount * ( advanceRate / 100 );
      const feeAmount = invoiceAmount * ( factoringFeePercent / 100 );
      const netAmount = invoiceAmount - feeAmount;
      const effectivePercent = ( feeAmount / invoiceAmount ) * 100;

      el.querySelector( '[data-js="result-advance"]' ).textContent = COMPONENT.formatCurrency( advanceAmount );
      el.querySelector( '[data-js="result-fee"]' ).textContent = COMPONENT.formatCurrency( feeAmount );
      el.querySelector( '[data-js="result-net"]' ).textContent = COMPONENT.formatCurrency( netAmount );
      el.querySelector( '[data-js="result-effective"]' ).textContent = effectivePercent.toFixed( 1 ).replace( /\.0$/, '' ) + '%';

      el.querySelector( '[data-js="calculator-results"]' ).classList.remove( 'hidden' );
    },

    formatCurrency: function( num ) {
      if ( isNaN( num ) ) return '$0';
      return num.toLocaleString( 'en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2} );
    },

    finalize: function() {},
  };

  app.registerComponent( 'cost-calculator', COMPONENT );
} )( app );
